import React, { useState, useEffect, useCallback } from "react";

import { Table, Space, Button, Popconfirm, Row } from "antd";

import {
  EditOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
  EyeOutlined,
} from "@ant-design/icons";

import {
  CampoBuscaInstantanea,
  destacarBusca,
  useBuscaInstantanea,
} from "../../../../components/CampoBuscaInstantanea";
import { SecaoCard } from "../../../../components/SecaoCard";

import { ModalAdd } from "./components/ModalAdd";
import { openNotification } from "../../../../components/Notification";
import { frequenciaService } from "../../../../services/resources/frequenciaService";

export const FrequenciaOcorrencia = () => {
  const [frequencia, setFrequencia] = useState([]);
  const { busca, onChangeBusca, filtrados, paginacaoBusca } =
    useBuscaInstantanea(frequencia, ["descricao"]);

  const [openModal, setOpenModal] = useState(false);

  const [codigo, setCodigo] = useState(null);
  const [codigoDelete, setCodigoDelete] = useState(null);
  const [mode, setMode] = useState("");

  const [disabled, setDisabled] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  useEffect(() => {
    getFrequencia();
    // eslint-disable-next-line
  }, []);

  async function getFrequencia() {
    try {
      const { data } = await frequenciaService.loadFrequencias();
      transformList(data);
    } catch (error) {
      openNotification(
        "error",
        <strong>Ocorreu um erro ao buscar a lista de frequencias!</strong>,
        error?.response?.data?.detail
      );
    }
  }

  async function handleDelete(codigo) {
    setConfirmLoading(true);
    setDisabled(true);
    try {
      await frequenciaService.delete(codigo);
      openNotification("success", <strong>Frequência excluída!</strong>);
      getFrequencia();
    } catch (reason) {
      openNotification(
        "error",
        <strong>Não foi possível excluir a frequência!</strong>,
        reason?.response?.data?.detail
      );
    } finally {
      setCodigoDelete(null);
      setConfirmLoading(false);
      setDisabled(false);
    }
  }

  const handleOpenModal = useCallback((frequencia) => {
    setOpenModal(true);
    setCodigo(frequencia?.codigo);
  }, []);

  const handleCloseModal = useCallback(() => {
    setOpenModal(false);
  }, []);

  const transformList = useCallback((list) => {
    list.sort(function (a, b) {
      return a.descricao > b.descricao ? 1 : b.descricao > a.descricao ? -1 : 0;
    });
    setFrequencia(list);
  }, []);

  const renderTable = () => {
    const columns = [
      {
        title: <strong>Descrição</strong>,
        dataIndex: "descricao",
        key: "descricao",
        render: (descricao) => destacarBusca(descricao, busca),
      },
      {
        title: <strong>ações</strong>,
        key: "action",
        width: 64,
        render: (frequencia) => (
          <Space size="small">
            <Button
              type="primary"
              className="action-button"
              ghost
              title={`Visualizar frequência ${frequencia?.descricao}`}
              onClick={() => {
                handleOpenModal(frequencia);
                setMode("onView");
              }}
            >
              <EyeOutlined style={{ fontSize: "1.2rem" }} />
            </Button>
            <Button
              type="primary"
              className="action-button"
              title={`Editar frequência ${frequencia?.descricao}`}
              onClick={() => {
                handleOpenModal(frequencia);
                setMode("onEdit");
              }}
            >
              <EditOutlined style={{ fontSize: "1.2rem" }} />
            </Button>
            <div>
              <Popconfirm
                title={
                  <span>
                    excluir frequência <strong>{frequencia?.descricao}</strong>
                    ?"
                  </span>
                }
                visible={frequencia?.codigo === codigoDelete}
                placement="bottomRight"
                okText="confirmar exclusão"
                cancelText="cancelar"
                icon={<QuestionCircleOutlined style={{ color: "red" }} />}
                onConfirm={() => handleDelete(frequencia?.codigo)}
                onCancel={() => setCodigoDelete(null)}
                okButtonProps={{ loading: confirmLoading }}
                disabled={disabled}
                cancelButtonProps={{ disabled: disabled }}
              >
                <Button
                  type="danger"
                  className="action-button"
                  title={`Excluir frequência ${frequencia?.descricao}`}
                  onClick={() => {
                    setCodigoDelete(frequencia?.codigo);
                  }}
                >
                  <DeleteOutlined style={{ fontSize: "1.2rem" }} />
                </Button>
              </Popconfirm>
            </div>
          </Space>
        ),
      },
    ];
    function showTotal(total) {
      return (
        <>
          Total de <strong>{total}</strong> frequências
        </>
      );
    }
    return (
      <Table
        dataSource={filtrados}
        columns={columns}
        size="small"
        rowKey={({ codigo }) => codigo}
        pagination={{
          ...paginacaoBusca,
          showTotal: showTotal,
        }}
      />
    );
  };

  return (
    <>
      <div className="container-section">
        <Row id="header">
          <h2>LISTA DE FREQUÊNCIAS</h2>

          <Button
            type="primary"
            onClick={() => {
              handleOpenModal(null);
              setMode("onCreate");
            }}
          >
            nova frequência
          </Button>
        </Row>
        <SecaoCard>
        <CampoBuscaInstantanea
          value={busca}
          onChange={onChangeBusca}
          placeholder="Busque pela frequência"
        />
        {renderTable()}
        </SecaoCard>
      </div>

      {openModal && (
        <ModalAdd
          onClose={handleCloseModal}
          codigo={codigo}
          mode={mode}
          reload={getFrequencia}
        />
      )}
    </>
  );
};
